import styled from 'styled-components'

// Compoments
import { Dropdown } from '@sketch/components'

export const DropdownDivider = styled(Dropdown.Divider)`
  margin: 8px -8px;
`

export const DropdownItem = styled.li`
  list-style: none;
`
